'use client';

import 'BomdisoftComponents/navigation/navigation-layout/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import { type CSSProperties, createElement, type ElementType, type ReactNode } from 'react';

export type NavigationLayoutProps = {
  children: ReactNode;
  component?: ElementType;
  dock: ReactNode;
  /** Background painted behind the top bar (CSS `background`: colour or gradient). Set it to match
   * the app's hero so the header blends into the page. Omit for a transparent header (unchanged). */
  headerBackground?: string;
  mainId?: string;
  mainClassName?: string;
  testId?: string;
  topBar: ReactNode;
};

export const NavigationLayout = ({ children, component = 'main', dock, headerBackground, mainId, mainClassName, testId, topBar }: NavigationLayoutProps) => (
  <>
    {headerBackground != null && <div aria-hidden className='bomdisoft-navigation-layout-header-band' data-testid='nav-header-background' style={{ '--nav-header-bg': headerBackground } as CSSProperties} />}
    {topBar}
    {dock}
    {createElement(component, { className: joinClasses('bomdisoft-navigation-layout-main', mainClassName), 'data-testid': testId, id: mainId }, children)}
  </>
);
